import { createContext } from "react";

export const StepLock = createContext();
